import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { Link, router } from '@inertiajs/react'

export default function Join({ activity, team, already_joined, store_token }) {
  function handleJoin() {
    router.post(`/teams/${team.id}/activities/${activity.id}/join`)
  }

  return (
    <AuthenticatedLayout>
      <div className="max-w-lg mx-auto mt-12">
        <div className="bg-white rounded-xl border border-gray-200 p-8 space-y-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{activity.name}</h1>
            <p className="text-sm text-gray-500 mt-1">{team.name}</p>
          </div>

          {already_joined ? (
            <div className="space-y-4">
              <p className="text-gray-700">Du har redan gått med i den här aktiviteten.</p>
              <div className="flex gap-3">
                <a
                  href={`/stores/${store_token}`}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700"
                >
                  Visa min butik →
                </a>
                <Link
                  href="/dashboard"
                  className="inline-flex items-center px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50"
                >
                  Tillbaka till startsidan
                </Link>
              </div>
            </div>
          ) : (
            <div className="space-y-4">
              <p className="text-gray-700">
                Gå med i den här aktiviteten för att starta din personliga butik och börja sälja.
              </p>
              <button
                onClick={handleJoin}
                className="w-full flex justify-center py-3 px-4 bg-indigo-600 text-white text-sm font-semibold rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                Gå med och starta min butik
              </button>
            </div>
          )}
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
